import React, { useEffect, useState } from 'react';
import { safeGet, safeSet, safeRemove, safeJsonParse, getSafeSession } from '../utils/browserSafe';
import baseURL from '../url';
import moneda from '../moneda';
import { getGeoCountryParam } from '../Geo/geoPricing';
import './OfferCountdown.css';

function timeLeft(end) {
  const diff = new Date(end).getTime() - Date.now();
  if (diff <= 0) return '00:00:00';
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return `${d > 0 ? d + 'd ' : ''}${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
}

function addOfferToCart(offer) {
  if (!offer?.idProducto) return;
  const cart = safeJsonParse(safeGet('cart','[]'), []);
  const existing = cart.find(item => Number(item.idProducto) === Number(offer.idProducto));
  if (existing) existing.cantidad = Number(existing.cantidad || 1) + 1;
  else cart.push({ idProducto: Number(offer.idProducto), item: [], cantidad: 1 });
  safeSet('cart', JSON.stringify(cart));
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('cartUpdated'));
}

export default function OfferCountdown(){
  const [offers,setOffers]=useState([]);
  const [selected,setSelected]=useState(null);
  const [,setTick]=useState(0);

  useEffect(()=>{ 
    fetch(`${baseURL}/offersGet.php${getGeoCountryParam()}`)
      .then(r=>r.json())
      .then(d=>setOffers(d?.offers||[]))
      .catch(()=>{}); 
  },[]);

  useEffect(()=>{ const id=setInterval(()=>setTick(t=>t+1),1000); return()=>clearInterval(id); },[]);

  if(!offers.length) return null;
  const offer = offers[0];

  const buy = (target) => {
    addOfferToCart(target);
    setSelected(null);
  };

  return <>
    <button className="offerCountdown" type="button" onClick={()=>setSelected(offer)}>
      <div className="offerPulse">🔥</div>
      <div className="offerText">
        <strong>{offer.title || 'Oferta limitada'}</strong>
        <span>{offer.subtitle || (offer.productoTitulo ? `Oferta en ${offer.productoTitulo}` : 'Compra esto, no te lo pierdas')}</span>
      </div>
      <b>Termina en {timeLeft(offer.endsAt)}</b>
      <span className="offerTap">Ver oferta</span>
    </button>

    {selected && (
      <div className="offerModalOverlay" onClick={()=>setSelected(null)}>
        <div className="offerModal" onClick={(e)=>e.stopPropagation()}>
          <button className="offerClose" onClick={()=>setSelected(null)}>×</button>
          <div className="offerModalHero">
            {selected.displayImage ? <img src={selected.displayImage} alt={selected.title} /> : <div className="offerNoImage">KY-13</div>}
            <div>
              <span className="offerBadge">Oferta Flash</span>
              <h2>{selected.title}</h2>
              <p>{selected.subtitle || 'Oferta por tiempo limitado para Mercadito KY-13.'}</p>
              {selected.productoTitulo && <h3>{selected.productoTitulo}</h3>}
              {selected.productoDescripcion && <p className='offerProductDesc'>{selected.productoDescripcion}</p>}
              {(selected.displayPrice || selected.precio) && <strong className="offerPrice">{moneda} {Number(selected.displayPrice || selected.precio || 0).toFixed(2)} <small>{selected.displayCurrency || 'CUP'}</small></strong>}
              <div className="offerClock">⏰ Quedan {timeLeft(selected.endsAt)}</div>
              {selected.idProducto ? (
                <button className="offerAddBtn" onClick={()=>buy(selected)}>Agregar al carrito</button>
              ) : (
                <button className="offerAddBtn" onClick={()=>setSelected(null)}>Explorar tienda</button>
              )}
            </div>
          </div>
        </div>
      </div>
    )}
  </>
}
